import {useTheme} from 'contexts/ThemeContext';
import React from 'react';
import {Text, View, Platform} from 'react-native';
import {getFirstLettersFromUsername} from 'helpers/getFirstLettersFromUsername';
import styleSheet from './styles';

export interface ProfilePhotoWithoutImageProps {
  isBigPhoto: boolean;
  name: string;
  isPhotoOnTheHomeGreeting: boolean;
}

const ProfilePhotoWithoutImage = (props: ProfilePhotoWithoutImageProps) => {
  const styles = styleSheet(
    useTheme(),
    props.isBigPhoto,
    props.isPhotoOnTheHomeGreeting,
  );

  return Platform.OS !== 'web' &&
    !props.isBigPhoto &&
    !props.isPhotoOnTheHomeGreeting ? (
    <View style={styles.maineUserContainer}>
      <View style={styles.userContainer}>
        <Text style={styles.userTextForPhoto}>
          {getFirstLettersFromUsername(props.name)}
        </Text>
      </View>
      <Text style={styles.userText}>{props.name}</Text>
    </View>
  ) : (
    <View style={styles.userContainer}>
      <Text style={styles.userTextForPhoto}>
        {getFirstLettersFromUsername(props.name)}
      </Text>
    </View>
  );
};

export default ProfilePhotoWithoutImage;
